import mapKeys from 'lodash/mapKeys';
import camelCase from 'lodash/camelCase';
import capitalize from 'lodash/capitalize';

export const mapArrayDtoPropsToCamelCase = (dtoList: any[]): any[] => {
    return dtoList == null ? [] : dtoList.map((dtoItem) => mapKeys(dtoItem, (v, key) => camelCase(key)));
};

export const mapDtoPropsToCamelCase = <T>(dtoItem: any): any => {
    return dtoItem == null ? null : mapKeys(dtoItem, (v, key) => camelCase(key));
};

export const capitalizeArrayDtoProps = (dtoList: any[]): any[] => {
    return dtoList == null ? [] : dtoList.map((dtoItem) => mapKeys(dtoItem, (v, key) => capitalize(key)));
};

export const captializeDtoProps = <T>(dtoItem: any): any => {
    return dtoItem == null ? null : mapKeys(dtoItem, (v, key) => capitalize(key));
};
